export default defineNuxtRouteMiddleware((to, from) => {
  // if (to.path !== from.path && process.client) {
  //   console.log("to.path", to.path);
  //   console.log("from.path", from.path);
  //   console.log("process.client", process.client);
  //   document.body.scrollTo(0, 0);
  // }
});
